// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"8071952e","211":"0ee57ec6","643":"898731ba","646":"c34fe8ac","648":"894afcd0","702":"5e76e344","748":"14c4d3c0","872":"f13ce756","969":"3a64cc74","972":"920bb671"}[chunkId] + ".chunk.css";
};